export default "__VITE_ASSET__CCgLMXLY__"